import { createContext, useContext } from "react";
import { IS_DEMO_EMBED } from "@/integrations/supabase/client";

/**
 * Read-only "showcase mode" UI layer (P6-C / B3).
 *
 * `readOnly` is true inside the marketing live embed (the scoped viewer
 * session). It is the SOFT layer on top of the hard server guards
 * (fn_demo_readonly_guard + the edge outbound guards): it lets us disable
 * actionable controls and no-op convenience writes so the demo *feels* live
 * instead of throwing "read-only" errors when a visitor pokes it. Nothing here
 * is a security boundary — the server is. It just makes the guarded surface
 * pleasant to click around.
 */
interface DemoModeValue {
  readOnly: boolean;
}

const DemoModeContext = createContext<DemoModeValue>({ readOnly: false });

export function DemoModeProvider({ children }: { children: React.ReactNode }) {
  return (
    <DemoModeContext.Provider value={{ readOnly: IS_DEMO_EMBED }}>
      {children}
    </DemoModeContext.Provider>
  );
}

export function useDemoMode(): DemoModeValue {
  return useContext(DemoModeContext);
}

/** Non-hook check for module-level / imperative code paths. */
export const isDemoReadOnly = (): boolean => IS_DEMO_EMBED;
